import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocalStorage } from '../constants/local-storage.constant';
import { LocalStorageService } from '../service/local-storage.service';
import { SharedService } from '../service/shared.service';
import { ToasterService } from '../service/toaster.service';

@Injectable()
export class HRMSInterceptor implements HttpInterceptor {

  constructor(private localStorageService: LocalStorageService,
    private sharedService: SharedService,
    private route: Router,
    private _toasterService: ToasterService) {

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.localStorageService.getData(LocalStorage.TOKEN)}`
      }
    });

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this._toasterService.showApiValidation({ errorCode: 401, errorMessage: '', errorTitle: "UnAuthorise Access" });
          this.sharedService.UserLogout();
          window.location.href = "/";
        }

        else if (err instanceof HttpErrorResponse && err.error instanceof Blob && err.error.type === "application/json") {
          return new Promise<any>((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = (e: Event) => {
              try {
                const errmsg = JSON.parse((<any>e.target).result);
                reject(
                  new HttpErrorResponse({
                    error: errmsg,
                    headers: err.headers,
                    status: err.status,
                    statusText: err.statusText,
                    url: err.url,
                  })
                );
              } catch (e) {
                reject(err);
              }
            };
            reader.onerror = (e) => {
              reject(err);
            };
            reader.readAsText(err.error);
          });
        } else {
          this._toasterService.showApiValidation({ errorCode: err.error.ErrorCode, errorMessage: err.error.ErrorMessage, errorTitle: err.error.ErrorTitle });
          return throwError(err.error);
        }
      })
    );

  }

}
